import axios from "axios";

export const GET_DISCONNECT_HOLDS = "GET_DISCONNECT_HOLDS";
export const GET_DISCONNECT_HOLDS_RESPONSE = "GET_DISCONNECT_HOLDS_RESPONSE";
export const GET_DISCONNECT_HOLDS_FAIL = "GET_DISCONNECT_HOLDS_FAIL";

export const POST_DISCONNECT_HOLD = "POST_DISCONNECT_HOLD";
export const POST_DISCONNECT_HOLD_RESPONSE = "POST_DISCONNECT_HOLD_RESPONSE";
export const POST_DISCONNECT_HOLD_FAIL = "POST_DISCONNECT_HOLD_FAIL";

export const PUT_DISCONNECT_HOLD = "PUT_DISCONNECT_HOLD";
export const PUT_DISCONNECT_HOLD_RESPONSE = "PUT_DISCONNECT_HOLD_RESPONSE";
export const PUT_DISCONNECT_HOLD_FAIL = "PUT_DISCONNECT_HOLD_FAIL";

export const DELETE_DISCONNECT_HOLD = "DELETE_DISCONNECT_HOLDS";
export const DELETE_DISCONNECT_HOLD_RESPONSE = "DELETE_DISCONNECT_HOLD_RESPONSE";
export const DELETE_DISCONNECT_HOLD_FAIL = "DELETE_DISCONNECT_HOLD_FAIL";

export const LIFT_DISCONNECT_HOLD = "LIFT_DISCONNECT_HOLD";
export const LIFT_DISCONNECT_HOLD_RESPONSE = "LIFT_DISCONNECT_HOLD_RESPONSE";
export const LIFT_DISCONNECT_HOLD_FAIL = "LIFT_DISCONNECT_HOLD_FAIL";

export const RESET = "RESET";

export function get(searchParams = {}, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_DISCONNECT_HOLDS,
      isLoading: isLoading,
    });

    const queryParams = {
      ...searchParams,
      page: searchParams.page !== undefined ? searchParams.page : 1,
      limit: searchParams.limit !== undefined ? searchParams.limit : 10,
    };

    return axios
      .get("/disconnecthold", { params: queryParams })
      .then((res) => {
        dispatch({
          type: GET_DISCONNECT_HOLDS_RESPONSE,
          disconnectHolds: res.data.data || [],
          total: res.data.total || 0,
          page: parseInt(queryParams.page),
          limit: parseInt(queryParams.limit),
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DISCONNECT_HOLDS_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function getByUuid(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_DISCONNECT_HOLDS,
      isLoading: isLoading,
    });

    return axios
      .get(`/disconnecthold/${uuid}`)
      .then((res) => {
        const disconnectHold = res.data;
        dispatch({
          type: GET_DISCONNECT_HOLDS_RESPONSE,
          disconnectHolds: { items: [disconnectHold], totalRows: 1 },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DISCONNECT_HOLDS_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function post(disconnectHold, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: POST_DISCONNECT_HOLD,
      isLoading,
    });

    return axios
      .post("/disconnecthold", disconnectHold)
      .then((response) => {
        dispatch({
          disconnectHold: response.data,
          type: POST_DISCONNECT_HOLD_RESPONSE,
        });
      })
      .catch((error) => {
        dispatch({
          type: POST_DISCONNECT_HOLD_FAIL,
          error: error,
        });
      });
  };
}

export function put(disconnectHold, uuid, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: PUT_DISCONNECT_HOLD,
      isLoading,
    });

    const holdUuid = uuid || disconnectHold.uuid;
    const { uuid: _, ...holdPayload } = disconnectHold;

    return axios
      .put(`/disconnecthold/${holdUuid}`, holdPayload)
      .then((response) => {
        dispatch({
          disconnectHold: response.data,
          type: PUT_DISCONNECT_HOLD_RESPONSE,
        });
      })
      .catch((error) => {
        dispatch({
          type: PUT_DISCONNECT_HOLD_FAIL,
          error: error,
        });
      });
  };
}

export function deleteDisconnectHold(uuid, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: DELETE_DISCONNECT_HOLD,
      isLoading,
    });

    return axios
      .delete(`/disconnecthold/${uuid}`)
      .then((response) => {
        dispatch({
          type: DELETE_DISCONNECT_HOLD_RESPONSE,
        });
      })
      .catch((error) => {
        dispatch({
          type: DELETE_DISCONNECT_HOLD_FAIL,
          error: error,
        });
      });
  };
}

export function liftDisconnectHold(uuid, liftReason, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: LIFT_DISCONNECT_HOLD,
      isLoading,
    });

    return axios
      .put(`/disconnecthold/${uuid}/lift`, { liftReason })
      .then((response) => {
        dispatch({
          disconnectHold: response.data,
          type: LIFT_DISCONNECT_HOLD_RESPONSE,
        });
      })
      .catch((error) => {
        dispatch({
          type: LIFT_DISCONNECT_HOLD_FAIL,
          error: error,
        });
      });
  };
}

export const POST_DISCONNECT_HOLDS_BULK = "POST_DISCONNECT_HOLDS_BULK";
export const POST_DISCONNECT_HOLDS_BULK_RESPONSE = "POST_DISCONNECT_HOLDS_BULK_RESPONSE";
export const POST_DISCONNECT_HOLDS_BULK_FAIL = "POST_DISCONNECT_HOLDS_BULK_FAIL";

export function postBulk(disconnectHolds, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: POST_DISCONNECT_HOLDS_BULK,
      isLoading,
    });

    return axios
      .post("/disconnecthold-bulk", { disconnectHolds })
      .then((response) => {
        dispatch({
          type: POST_DISCONNECT_HOLDS_BULK_RESPONSE,
          data: response.data,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: POST_DISCONNECT_HOLDS_BULK_FAIL,
          error: error.response?.data?.ERROR || error.response?.data?.message || error.message || 'Failed to create bulk disconnect holds',
        });
        throw error;
      });
  };
}

export function reset() {
  return {
    type: RESET,
  };
}
